export default __webpack_public_path__ + "static/media/wsp.209a7d04.png";